(function(){

    'use strict';

    var pwa_install_prompt = function() {

        // Function to get a cookie value
        function getCookie(cname) {

            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return '';

        }

        // Function to set a cookie
        function setCookie(cname, cvalue, exdays) {

            var expires;
    
            if (exdays) {
                var d = new Date();
                d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
                expires = 'expires=' + d.toUTCString();
            } else {
                expires = "";
            }
            
            document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    
        }

        // Function to check if cookie is active against a provided value
        function isCookieActive(cookie_name, cookie_active_value) {

            var current_cookie_value = getCookie(cookie_name);

            if (current_cookie_value === cookie_active_value) {
                return true;
            } else {
                return false;
            }

        }

        // Get Operating System
        function getOS() {

            var userAgent = window.navigator.userAgent;
            var platform = window.navigator.platform;
            var macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
            var windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
            var iosPlatforms = ['iPhone', 'iPad', 'iPod'];
            var os = null;

            if (macosPlatforms.indexOf(platform) !== -1) {
                os = 'Mac OS';
            } else if (iosPlatforms.indexOf(platform) !== -1) {
                os = 'iOS';
            } else if (windowsPlatforms.indexOf(platform) !== -1) {
                os = 'Windows';
            } else if (/Android/.test(userAgent)) {
                os = 'Android';
            } else if (!os && /Linux/.test(platform)) {
                os = 'Linux';
            }

            return os;
        }

        // Check if user is on a mobile device brwoser
        function isOnMobile() {
            return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
        }

        //Check if user is on a Chromium browser with install prompt support
        function isOnChromeWithInstallSupport() {
            var returnValue = false;

            //https://stackoverflow.com/questions/4565112/javascript-how-to-find-out-if-the-user-browser-is-chrome/13348618#13348618
            var isChromium = window.chrome;
            var winNav = window.navigator;
            var vendorName = winNav.vendor;
            var isOpera = typeof window.opr !== "undefined";
            var isIEedge = winNav.userAgent.indexOf("Edg") > -1;
            var isIOSChrome = winNav.userAgent.match("CriOS");

            if (isIOSChrome) {
                // is Google Chrome on IOS
            } else if (
                isChromium !== null &&
                typeof isChromium !== "undefined" &&
                vendorName === "Google Inc." &&
                isOpera === false &&
                isIEedge === false
            ) {
                // is Google Chrome
                returnValue = true;
                // TODO: also test for edge;
            } else {
                // not Google Chrome 
            }

            return returnValue;
        }

        // Detects if device is in standalone mode - which is a saved pwa
        function isInStandaloneMode() {
            return ('standalone' in window.navigator) && (window.navigator.standalone)
        }

        function setupInstallButtons() {
            
            var button_install = document.querySelector('#smp-pwa-install-prompt__install-btn');
            var button_cancel = document.querySelector('#smp-pwa-install-prompt__cancel-btn');

            button_install.addEventListener('click', function (e) {
                
                // Hide our custom prompt that shows our A2HS button
                hideInstallPrompt();

                // Show the prompt
                deferred_prompt.prompt();

                // Wait for the user to respond to the prompt
                deferred_prompt.userChoice.then((choiceResult) => {

                    if (choiceResult.outcome === 'accepted') {
                        // console.log('User accepted the A2HS prompt');
                    } else {
                        // console.log('User dismissed the A2HS prompt');
                    }

                    deferred_prompt = null;

                });

            });

            button_cancel.addEventListener('click', function () {
                
                installPromptDismissed();

                // Clear the deferredPrompt so it can be garbage collected
                deferred_prompt = null;

            });

        }

        function hideInstallPrompt() {

            install_prompt_element.classList.remove('shown');

        }

        function showInstallPrompt() {

            install_prompt_element.classList.add('shown');

        }

        function installPromptDismissed() {

            // Hide the app-provided install promotion
            hideInstallPrompt();
                
            // Set a cookie that will eventually expire
            // Cookie will ensure prompt is not shown until cookie expires
            setCookie(install_prompt_dismissed_cookie_name, install_prompt_dismissed_cookie_active_value, install_prompt_dismissed_cookie_expiry_days);

        }

        function setupBeforeInstallPrompt() {

            // Override to prevent default install prompt and show custom one
            window.addEventListener('beforeinstallprompt', (event) => {
                        
                // Always prevent the mini-infobar from appearing on mobile regardless of our cookie settings
                // This is because the mini-info bar (if app not installed) will always show even if this custom beforeinstallprompt eventListerner is not set up
                event.preventDefault();
                
                if (is_site_notice_dismissed_cookie_active && !is_install_prompt_dismissed_cookie_active) {

                    // Stash the event so it can be triggered later.
                    deferred_prompt = event;
                
                    setupInstallButtons();

                    showInstallPrompt();

                }

            });

        }

        function changeInstallPromptInstructions() {

            // If user is not on an Android or a supported Chrome browser
            // Tweak the install instructions
            var instructions = "1) Open browser settings (three dots). 2) Select 'Install app'";

            //detect if ios safari
            var ua = window.navigator.userAgent;
            var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
            var webkit = !!ua.match(/WebKit/i);
            var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);

            var browser = (function (agent) {
                switch (true) {
                    case agent.indexOf("edge") > -1: return "edge";
                    case agent.indexOf("edg") > -1: return "edgenew";
                    case agent.indexOf("opr") > -1 && !!window.opr: return "opera";
                    case agent.indexOf("chrome") > -1 && !!window.chrome: return "chrome";
                    case agent.indexOf("trident") > -1: return "ie";
                    case agent.indexOf("firefox") > -1: return "firefox";
                    case agent.indexOf("safari") > -1: return "safari";
                    default: return "other";
                }
            })(window.navigator.userAgent.toLowerCase());

            if (iOSSafari) {

                instructions = "1) Select the 'Share' button. 2) Select 'Add to Home Screen'"

            } else {
                
                switch (browser) {
                    case "firefox":
                        instructions = "1) Open browser settings (three dots). 2) Select 'Install'"
                        break;
                    case "edgenew":
                        instructions = "1) Open browser settings (three dots). 2) Select 'Add to Screen'"
                        break;
                }

            }

            document.querySelector('.smp-pwa-install-prompt__instructions').innerHTML = instructions;

        }

        function toggleContentVisibility() {

            // Show the content we want when user can't install from browser
            document.querySelectorAll('.smp-pwa-install-prompt__show-when-cant-install').forEach(function (item) {
                item.classList.remove('d-none');
            })

            // Hide the content we don't want when user cant install from browser
            document.querySelectorAll('.smp-pwa-install-prompt__show-when-can-install').forEach(function (item) {
                item.classList.add('d-none');
            });
            
        }

        function setupCloseButton() {

            var button_close = document.querySelector('#smp-pwa-install-prompt__close-btn');

            button_close.addEventListener('click', function (e) {
                
                installPromptDismissed();

            });

        }

        function init() {

            install_prompt_element = document.querySelector('.smp-pwa-install-prompt');

            if (typeof(install_prompt_element) != 'undefined' && install_prompt_element != null) {

                // Only show install prompt if:
                // - On mobile
                // - In stand alone mode
                
                if (isOnMobile() && !isInStandaloneMode()) {

                    if (getOS() === "Android" && isOnChromeWithInstallSupport()) {
                        
                        // Native PWA install prompt is available
                        setupBeforeInstallPrompt();
    
                    } else {
                        
                        // Only show instructions if 
                        // - Site notice cookie has been dismissed before
                        // - Install prompt cookie has not been dismissed before

                        if (is_site_notice_dismissed_cookie_active && !is_install_prompt_dismissed_cookie_active) {

                            // Identify OS and tweak the install instructions
                            changeInstallPromptInstructions();
                            setupCloseButton();
                            toggleContentVisibility();

                            showInstallPrompt();

                        }

                    }                    
    
                }

            }

        }

        var install_prompt_element;
        var deferred_prompt;
        
        var install_prompt_dismissed_cookie_name = "pwa-install-prompt-dismissed";
        var install_prompt_dismissed_cookie_active_value = "true";
        var install_prompt_dismissed_cookie_expiry_days = 30;
        
        var site_notice_dismissed_cookie_name = "site_notice_dismissed";
        var site_notice_dismissed_cookie_active_value = "true";

        var is_site_notice_dismissed_cookie_active = isCookieActive(site_notice_dismissed_cookie_name, site_notice_dismissed_cookie_active_value);
        var is_install_prompt_dismissed_cookie_active = isCookieActive(install_prompt_dismissed_cookie_name, install_prompt_dismissed_cookie_active_value);

        return {
            init: init
        };

    }();

    document.addEventListener("DOMContentLoaded", function () {
        pwa_install_prompt.init();
    });

}());